/**
 * Configuración de Meta Pixel para Transfer Is OK
 * Aquí se centralizan todas las configuraciones relacionadas con Meta Pixel
 */

// Configuración principal de Meta Pixel
export const META_PIXEL_CONFIG = {
    // Pixel ID de Transfer Is OK
    pixelId: process.env.REACT_APP_META_PIXEL_ID || '1451884132660626',

    // ⚠️ NUNCA exponer access tokens en el frontend
    // Los tokens se manejan de forma segura en el backend a través de Firebase Functions

    // Configuración de eventos
    events: {
        // Valores por defecto para eventos
        currency: 'ARS',

        // Configuración de eventos específicos
        viewContent: {
            registrationStep1: {
                content_type: 'registration_form',
                content_name: 'Transfer Is OK - Registro Paso 1',
                content_category: 'Registration',
                value: 0
            },
            registrationStep2: {
                content_type: 'registration_form',
                content_name: 'Transfer Is OK - Registro Paso 2',
                content_category: 'Registration',
                value: 50
            }
        },

        lead: {
            stepCompleted: {
                content_name: 'Transfer Is OK - Datos Básicos Completados',
                content_category: 'Registration Step 1',
                value: 1500  // Valor estimado de capturar un lead empresarial
            }
        },

        initiateCheckout: {
            stepAdvancement: {
                content_name: 'Transfer Is OK - Avanza a Datos del Negocio',
                content_category: 'Registration Step 2',
                value: 50
            }
        },

        completeRegistration: {
            finished: {
                content_name: 'Transfer Is OK - Registro Completo',
                content_category: 'Registration Complete',
                value: 4000  // Valor estimado de un registro completo (15% de $29k)
            }
        }
    }
};

// Configuración de páginas que deben ser trackeadas
export const TRACKABLE_PAGES = [
    '/registro',
    '/registro/datos',
    '/registro/negocio',
    '/auth/callback',
    '/bienvenida'
];

// Configuración de campos del formulario para tracking
export const FORM_FIELDS_CONFIG = {
    registerData: {
        fields: ['fullName', 'businessName', 'email', 'confirmEmail'],
        totalFields: 4,
        step: 'register_data'
    },
    businessData: {
        fields: ['DNI_CUIT', 'phone', 'branches', 'sector', 'employees', 'mainAddress'],
        totalFields: 6,
        step: 'business_data'
    }
};

// Configuración de eventos personalizados
export const CUSTOM_EVENTS = {
    FORM_INTERACTION: 'FormInteraction',
    FORM_PROGRESS: 'FormProgress',
    FORM_ERROR: 'FormError',
    FORM_VALIDATION_ERROR: 'FormValidationError',
    INFO_SECTION_TOGGLE: 'InfoSectionToggle',
    PAGE_VIEW: 'PageView',
    UTM_CAPTURE: 'UTMCapture',
    REGISTRO_HACIA_MP: 'RegistroHaciaMercadoPago'
};

// Configuración para debugging y desarrollo
export const DEBUG_CONFIG = {
    enabled: process.env.NODE_ENV === 'development',
    logEvents: true,
    logUserData: false, // Por privacidad, no loguear datos de usuario en producción
    testMode: process.env.NODE_ENV === 'development'
};

// Función para obtener configuración de evento
export const getEventConfig = (eventType, eventSubtype) => {
    return META_PIXEL_CONFIG.events[eventType]?.[eventSubtype] || {};
};

// Función para validar si una página debe ser trackeada
export const shouldTrackPage = (pathname) => {
    return TRACKABLE_PAGES.some(page => pathname.startsWith(page));
};

// Función para obtener configuración de campos de formulario
export const getFormConfig = (formType) => {
    return FORM_FIELDS_CONFIG[formType] || null;
};

export default META_PIXEL_CONFIG; 